var render = function () {
  var _vm$user;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', {
    staticClass: "m-0",
    attrs: {
      "align-h": "between"
    }
  }, [(_vm$user = _vm.user) !== null && _vm$user !== void 0 && _vm$user.firstName ? _c('h1', {
    staticClass: "header-text"
  }, [_vm._v(" " + _vm._s("Hello, ".concat(_vm.user.firstName, "!")) + " ")]) : _vm._e(), _c('b-row', {
    staticClass: "user-box",
    attrs: {
      "align-v": "center"
    }
  }, [_c('img', {
    staticClass: "user-avatar",
    attrs: {
      "src": require("@/assets/navbar/avatar.svg"),
      "alt": "User avatar"
    }
  }), _vm.user ? _c('div', [_c('p', {
    staticClass: "user-name"
  }, [_vm._v(" " + _vm._s("".concat(_vm.user.firstName, " ").concat(_vm.user.lastName)) + " ")]), _c('p', {
    staticClass: "user-email"
  }, [_vm._v(_vm._s(_vm.user.email))])]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }